import styled from '@emotion/styled';
import { Colors } from 'utils';
import PropTypes from 'prop-types';
import device from './device';
const PrimaryButton = styled.button`
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;

  height: 44px;
  padding: 10px 16px;
  min-width: ${({ minWidth }) => minWidth || '151px'};

  background: ${({ primary }) => (primary ? '#ffffff' : '#9dbc60')};
  border: ${({ primary }) => (primary ? '1px solid #d5d7da' : 'none')};
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  border-radius: 8px;

  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ primary }) => (primary ? '#414651' : '#ffffff')};
  text-align: center;

  cursor: pointer;
  margin-bottom: 20px;
  appearance: none;
  transition: background 0.2s ease, transform 0.1s ease, opacity 0.2s ease;

  &:hover {
    background: ${({ primary }) => (primary ? '#f8f9fb' : '#3f621a')};
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    background: #cdd5c0;
    color: rgba(255, 255, 255, 0.75);
    border-color: transparent;
    cursor: not-allowed;
    box-shadow: none;
  }

  @media ${device.allMobile} {
    height: 44px;
    padding: 10px 16px;
    font-size: 16px;
  }
`;

export default PrimaryButton;

PrimaryButton.propTypes = {
  primary: PropTypes.bool,
  minWidth: PropTypes.string,
};
